import React from 'react';
import { Control, Controller } from 'react-hook-form';
import {  TextField, GridLegacy as Grid } from '@mui/material';
import { emailRegex } from '@cvt/helpers/validation';

interface RecipientDetailsSectionProps {
  control: Control<Gift.Crud>;
  dictionary: any;
}

export const RecipientDetailsSection: React.FC<RecipientDetailsSectionProps> = ({ control, dictionary }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <Controller
          name="recipientName"
          control={control}
          rules={{ required: dictionary.forms.validations.required }}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label="Recipient Name"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              fullWidth
              slotProps={{
                input: {
                  sx: {
                    'fieldset': {
                      borderRadius: '10px',
                    },
                  },
                },
              }}
            />
          )}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Controller
          name="recipientEmail"
          control={control}
          rules={{
            required: dictionary.forms.validations.required,
            pattern: {
              value: emailRegex,
              message: dictionary.forms.validations.invalidEmail,
            },
          }}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label="Recipient Email"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              fullWidth
              slotProps={{
                input: {
                  sx: {
                    'fieldset': {
                      borderRadius: '10px',
                    },
                  },
                },
              }}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};
